import React from 'react';
import cx from 'classnames';
import styles from "./Checkbox.module.scss";

const CheckBox = (props) => {
  const {
    checked,
    className,
    disabled,
    error,
    id,
    helperText,
    label,
    name,
    onChange,
    tabIndex,
    ...rest
  } = props;
  const hasError = !!(error && helperText);
  return (
    <div
      className={cx(styles.checkbox, {
        [styles[className]]: !!className,
      })}
    >
      <label
        className={cx(styles.checkbox__field, {
          [styles['checkbox__field--checked']]: !!checked,
        })}
      >
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          tabIndex={tabIndex}
          id={id}
          {...rest}
        />
        {label && <span className={styles.checkbox__label}>{label}</span>}
      </label>
      {hasError && <p className={styles.checkbox__error}>{helperText}</p>}
    </div>
  );
};

export default CheckBox;
